import * as React from 'react';
import { Link } from 'react-router-dom';

export const CategoryCard = ({ category, selectCategory }) => {
    return (<Link className='ui card' to={'categories/' + category.alias} onClick={(e) => selectCategory(category.alias)}>
        {category.image && <div className='image'>
            <img src={category.image} />
        </div>}
        <div className='content'>
            <div className='meta'>
                <span className='date'>{category.title}</span>
            </div>
        </div>
    </Link>);
}



// WEBPACK FOOTER //
// ./src/components/categories/category-card.presentation.tsx